<form [formGroup]="passForm" (ngSubmit)="checkForm() && !loading && sendForgot()">
  <mat-form-field class="input-tg w-full" appearance="outline" hideRequiredMarker="true">
    <mat-label>E-mail</mat-label>
    <mat-icon matPrefix class="icone-campo" fontIcon="mail_outline"></mat-icon>
    <input id="email" type="email" matInput formControlName="email" autocomplete="email" placeholder="Insira seu e-mail" />
  </mat-form-field>

  <div class="flex flex-col gap-3 mt-2">
    <button
      mat-flat-button
      type="submit"
      class="btn-tg w-full h-12"
      [disabled]="!checkForm() || loading"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Enviar link de recuperação
      }
    </button>
    <button mat-button type="button" class="btn-tg-white w-full h-12" (click)="forgotPass()">
      Voltar ao login
    </button>
  </div>
</form>
